const initialState = "medium";

const display = (state = initialState, action) => {
    switch (action.type) {
        case 'HANDLE_DISPLAY':
            state = action.payload.display
            return state;

        default:
            return state;
    }
};

export default display;